import { z } from "zod";
import {
  ProfileTypesEnum,
  zBusinessProfileParameters,
  zClientProfileParameters,
  zCompanyProfileParameters,
  zProfessionalProfileParameters,
  zProfile,
} from "@dobrh-monorepo/core";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";

const requestSchema = z.union([
  z.object({
    profileType: z.literal(ProfileTypesEnum.CLIENT),
    profileData: zClientProfileParameters,
  }),
  z.object({
    profileType: z.literal(ProfileTypesEnum.COMPANY),
    profileData: zCompanyProfileParameters,
  }),
  z.object({
    profileType: z.literal(ProfileTypesEnum.PROFESSIONAL),
    profileData: zProfessionalProfileParameters,
  }),
  z.object({
    profileType: z.literal(ProfileTypesEnum.BUSINESS),
    profileData: zBusinessProfileParameters,
  }),
]);

const responseSchema = zProfile;

export default {
  method: HttpMethodEnum.POST,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
